export default {
  Detail: 0,
  Summary: 1,
};
